import React, { useState } from 'react';
import classnames from 'classnames';
import axios from 'axios';
import cookies from '../../utils/cookies';
import { useFormik } from 'formik';
import Input from '../../components/form/Input';
import { ReactComponent as CheckIcon } from '../../svg/check.svg';
import Layout from '../Layout';
import { passwordSchema } from '../../pages/Login';
import { object, string } from 'yup';

export const updateAccount = (username, data) => {
    return axios.request({
        url: `${process.env.REACT_APP_API_URL}/authorized/users/${username}`,
        method: 'patch',
        data
    });
};

const ChangePassword = () => {
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(false);
    const [invalid, setInvalid] = useState([]);

    const { values, isSubmitting, setFieldValue, handleSubmit } = useFormik({
        initialValues: {
            oldPassword: '',
            newPassword: ''
        },
        validationSchema: object().shape({
            oldPassword: string().label('Old Password').required('Please include the current password'),
            newPassword: string()
                .label('New Password')
                .required()
                .test('meets-reqs', 'Password does not meet the minimum password requirements.', async (value) => {
                    return await passwordSchema.validate(value || '');
                })
        }),
        onSubmit: async (values) => {
            await axios
                .request({
                    url: `${process.env.REACT_APP_API_URL}/unauthorized/changepassword`,
                    method: 'POST',
                    data: {
                        oldpassword: values.oldPassword,
                        newpassword: values.newPassword,
                        access_token: cookies.get('access_key')
                    }
                })
                .then(() => {
                    setSuccess(true);
                    setError(false);
                })
                .catch((e) => {
                    console.error(e);
                    setSuccess(null);
                    setError(true);
                });
        }
    });

    return (
        <Layout>
            <div className="page-header">
                <h1>Change Password</h1>
            </div>
            <div className="row">
                <div className="col-sm-6">
                    <form onSubmit={handleSubmit}>
                        <Input
                            id="oldPassword"
                            label="Current Password"
                            type="password"
                            value={values.oldPassword}
                            validators={['validPassword']}
                            isRequiredMsg="Password is required."
                            required
                            onChange={(id, value) => {
                                setFieldValue(id, value);
                            }}
                        />
                        <Input
                            id="newPassword"
                            label="New Password"
                            type="password"
                            value={values.newPassword}
                            validators={['validPassword']}
                            isRequiredMsg="Password is required."
                            required
                            onChange={(id, value) => {
                                setFieldValue(id, value);
                                setInvalid(passwordSchema.validate(value, { list: true }));
                            }}
                        />
                        <button
                            className={classnames('btn btn-sm', {
                                'btn-primary': success === null,
                                'btn-success': success
                            })}
                            type="submit"
                            disabled={isSubmitting || invalid.length > 0}
                        >
                            {isSubmitting ? (
                                'Saving...'
                            ) : success === null ? (
                                'Save'
                            ) : (
                                <>
                                    <CheckIcon width="1em" height="1em" /> Changes Saved
                                </>
                            )}
                        </button>
                        {error && <p>Error saving password.</p>}
                    </form>
                </div>
                <div className="col-sm-6">
                    <div className="card card-flat password-reqs">
                        <div className="card-header">
                            <h6>Password Requirements</h6>
                        </div>
                        <div className="card-body">
                            <ul className="list-unstyled">
                                <li>
                                    {!invalid.includes('min') && !!values.newPassword.length && (
                                        <span className="indicator indicator-success"></span>
                                    )}{' '}
                                    Minimum 8 characters
                                </li>
                                <li>
                                    {!invalid.includes('digits') && !!values.newPassword.length && (
                                        <span className="indicator indicator-success"></span>
                                    )}{' '}
                                    Include numbers
                                </li>
                                <li>
                                    {!invalid.includes('symbols') && !!values.newPassword.length && (
                                        <span className="indicator indicator-success"></span>
                                    )}{' '}
                                    Include special character
                                </li>
                                <li>
                                    {!invalid.includes('uppercase') && !!values.newPassword.length && (
                                        <span className="indicator indicator-success"></span>
                                    )}{' '}
                                    Include uppercase letters
                                </li>
                                <li>
                                    {!invalid.includes('lowercase') && !!values.newPassword.length && (
                                        <span className="indicator indicator-success"></span>
                                    )}{' '}
                                    Include lowercase letters
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ChangePassword;
